import { useState } from 'react'

import {
  useFilterStateLoader,
  useInfiniteItemsListLoader,
  useTableConfigLoader,
} from '../../../../hooks'

export function useAsyncListLoader({
  apiParams,
  beforeLoad,
  checkIsLastPage,
  entity,
  extraFilters,
  getApiParamsInit,
  getApiParamsUpdate,
  getData,
  getDataItems,
  getNextItems,
  getPermanentFilters,
  isLocalFilterState,
  listFilters,
  listPreloader,
  saveExtras,
  sub,
  thresholdEndIndex,
  onChangeInitialized,
  onChangePermissions,
  onFilterItems,
}) {
  const [isInitiated, setInitiated] = useState(false)

  const { availableFilters, handleLoadTableConfig } = useTableConfigLoader({
    entity,
  })

  const {
    filterValues,
    handleLoadFilterState,
    handleSetFilterValues,
    hasFilterChanged,
    ordering,
  } = useFilterStateLoader({
    beforeLoad,
    entity,
    getPermanentFilters,
    isLocal: isLocalFilterState,
    saveExtras,
    sub,
  })

  const listApiParams = {
    ...apiParams,
    filters: extraFilters ? { ...filterValues, ...extraFilters } : filterValues,
    ordering,
  }

  function getNextApiParams(items) {
    return getNextItems(
      items,
      extraFilters ? { ...filterValues, ...extraFilters } : filterValues
    )
  }

  const {
    getThresholdItemProps,
    items,
    loadingInitial,
    loadingMore,
    updateListData,
  } = useInfiniteItemsListLoader({
    apiParams: listApiParams,
    checkIsLastPage,
    filters: listFilters,
    getApiParamsInit,
    getApiParamsLoadNext: getNextApiParams,
    getApiParamsUpdate,
    getData,
    getDataItems,
    preloading: !isInitiated,
    thresholdEndIndex,
    onChangeInitialized,
    onChangePermissions,
    onFilterItems,
  })

  async function handleListConfigInit() {
    setInitiated(false)

    return Promise.all([
      listPreloader?.(),
      handleLoadTableConfig(),
      handleLoadFilterState(),
    ]).finally(() => setInitiated(true))
  }

  return {
    availableFilters,
    filterValues,
    getThresholdItemProps,
    handleListConfigInit,
    handleSetFilterValues,
    hasFilterChanged,
    isLoading: !isInitiated,
    items,
    listLoading: loadingInitial || loadingMore,
    loadingInitial,
    ordering,
    updateListData,
  }
}
